/* 

  This is a general-purpose download functionality.
  It is generic thanks to the Blob datatype.
  The function is used in the Menue.vue and in the Popup.vue.

  The function needs to be imported:
  import download from '../../util/download';

  ..and can the be called:
  download(JSON.stringify(modules), fileName + '.json', 'text/json');

  ..for CSV the contentType is: 'text/csv;charset=utf-8;'

*/


const download = (content, fileName, contentType) => {
  const a = document.createElement("a");
  const file = new Blob([content], {type: contentType});
  a.href = URL.createObjectURL(file);
  a.download = fileName;
  a.click();
}


export default download
